import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {gtmEvent} from '../store/actions/gtm'
import {getComponentDisplayName} from '../utils'

export default () => (Wrapped) => {
  const GtmEvent = props => <Wrapped {...{...props}} />
  
  const mapDispatchToProps = dispatch => bindActionCreators({gtmEvent}, dispatch)
  
  GtmEvent.displayName = `GtmEvent(${getComponentDisplayName(Wrapped)})`
  
  return connect(undefined, mapDispatchToProps)(GtmEvent)
}



// WEBPACK FOOTER //
// ./src/higher-order-components/gtm-event.jsx